<template>
    <div class="header-container">
        <div class="header-content">
            <!-- 左侧 Logo 和导航 -->
            <div class="left-section">
                <div class="logo" @click="goHome">
                    <img src="@/assets/logo.png" alt="点云研智网 - 专业3D定制与点云数字资产交易平台" class="logo-img">
                    <span class="logo-text">点云研智网</span>
                </div>
                <div class="nav-menu">
                    <div class="nav-list">
                        <div class="nav-item" :class="{ active: currentPath === '/' }" @click="nav_to('/')">
                            <span class="nav-link">首页</span>
                        </div>
                        <div class="nav-item has-dropdown" :class="{ active: currentPath.startsWith('/scene') }">
                            <span class="nav-link" @click="nav_to('/scene')">
                                3D点云库
                                <i class="arrow-icon ri-arrow-down-s-fill"></i>
                            </span>
                            <div class="dropdown-menu all-models scene-menu">
                                <div class="model-box">
                                    <div class="model-box-item" v-for="item in sceneList" :key="item.name"
                                        @click="handleSceneTypeClick(item)">
                                        <i v-if="item.cssIcon" class="format-icon" :class="item.cssIcon" :data-label="item.label">{{ item.cssIcon === 'format-ascii' ? '' : item.label }}</i>
                                        <i v-else :class="`iconfont ${item.icon}`" style="font-weight: 300;"></i>
                                        <span>{{ item.name }}</span>
                                    </div>
                                </div>
                                <div class="rbg-box">
                                    <div class="rbg-box-item" v-for="item in sceneRbgList" :key="item.name"
                                        @click="handleSceneClassifyClick(item)">
                                        <span>{{ item.name }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="nav-item has-dropdown" :class="{ active: currentPath.startsWith('/product') }">
                            <span class="nav-link" @click="nav_to_work">
                                3D定制
                                <i class="arrow-icon ri-arrow-down-s-fill"></i>
                            </span>
                            <div class="dropdown-menu all-models work-menu">
                                <div class="model-box">
                                    <div class="model-box-item" v-for="item in workClassifyList" :key="item.classifyId"
                                        @mouseenter="handleWorkClassifyHover(item)"
                                        @click="handleWorkClassifyClick(item)">
                                        <i v-if="item.cssIcon" class="format-icon" :class="item.cssIcon">{{ item.label }}</i>
                                        <i v-else :class="`iconfont ${item.icon}`" style="font-weight: 300;"></i>
                                        <span>{{ item.classifyName }}</span>
                                    </div>
                                </div>
                                <div class="rbg-box" v-if="(workHoveredClassify || defaultWorkClassify) && (workHoveredClassify || defaultWorkClassify).childrenList && (workHoveredClassify || defaultWorkClassify).childrenList.length > 0">
                                    <div class="rbg-box-item" v-for="child in (workHoveredClassify || defaultWorkClassify).childrenList"
                                        :key="child.classifyId" @click="handleWorkChildClassifyClick(child, workHoveredClassify || defaultWorkClassify)">
                                        <span>{{ child.classifyName }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 3D行业解决方案 - 暂时隐藏 -->
                        <!-- <div class="nav-item has-dropdown industry-solution-nav">
                            <span class="nav-link" @click="nav_to('/product')">
                                3D行业解决方案
                                <i class="arrow-icon ri-arrow-down-s-fill"></i>
                            </span>
                            <div class="dropdown-menu all-models industry-menu">
                                <div class="model-box">
                                    <div class="model-box-item" v-for="item in industrySolutionList" :key="item.id"
                                        @click="handleIndustrySolutionClick(item)">
                                        <i :class="item.icon" style="font-size: 18px;"></i>
                                        <span>{{ item.name }}</span>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                        <div class="nav-item" :class="{ active: currentPath.startsWith('/custom-service') }"
                            @click="nav_to('/custom-service')">
                            <span class="nav-link">定制服务</span>
                        </div>
                        <!-- 3D模型库 - 暂时隐藏 -->
                        <!-- <div class="nav-item has-dropdown" :class="{ active: currentPath.startsWith('/model') }">
                            <span class="nav-link" @click="nav_to('/model')">
                                3D模型库
                                <i class="arrow-icon ri-arrow-down-s-fill"></i>
                            </span>
                            <div class="dropdown-menu all-models model-menu">
                                <div class="model-box">
                                    <div class="model-box-item" v-for="item in modelList" :key="item.name"
                                        @click="handleModelTypeClick(item)">
                                        <i v-if="item.cssIcon" class="format-icon" :class="item.cssIcon">{{ item.label }}</i>
                                        <i v-else :class="`iconfont ${item.icon}`" style="font-weight: 300;"></i>
                                        <span>{{ item.name }}</span>
                                    </div>
                                </div>
                                <div class="rbg-box">
                                    <div class="rbg-box-item" v-for="item in rbgList" :key="item.name"
                                        @click="handleModelClassifyClick(item)">
                                        <span>{{ item.name }}</span>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                        <div class="nav-item has-dropdown" :class="{ active: currentPath.startsWith('/tutorial') }">
                            <span class="nav-link">
                                更多
                                <i class="arrow-icon ri-arrow-down-s-fill"></i>
                            </span>
                            <div class="dropdown-menu more-menu">
                                <div class="dropdown-item" v-for="item in moreMenuList" :key="item.id"
                                    @click="handleNavClick(item)">
                                    <span>{{ item.name }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 中间搜索区域 -->
            <div class="center-section">
                <div class="search-box">
                    <el-input v-model="searchText" clearable placeholder="请输入搜索关键词" class="search-input"
                        @keyup.enter.native="handleSearch">
                        <span class="search-btn" slot="append" @click="handleSearch">搜索</span>
                    </el-input>
                </div>
            </div>

            <!-- 右侧用户操作区域 -->
            <div class="right-section" v-if="!userInfo">
                <!-- <el-button type="text" class="auth-btn" @click="nav_to('/register')">注册</el-button> -->
                <el-button type="text" class="auth-btn" @click="nav_to('/login')">登录</el-button>
            </div>
            <div class="right-section" v-else>
                <div class="avatar-box">
                    <div class="avatar" style="width: 40px; height: 40px; border-radius: 50%; overflow: hidden;"
                        @click="goToUserCenter('buyer')">
                        <img :src="userInfo.avatar" :alt="userInfo.userName + '的头像 - 点云研智网'" style="width: 100%; height: 100%;">
                    </div>
                    <div class="user-box">
                        <div class="info-block">
                            <div class="avatar" style="width: 60px; height: 60px; border-radius: 50%; overflow: hidden;"
                                @click="goToUserCenter('buyer')">
                                <img :src="userInfo.avatar" :alt="userInfo.userName + '的头像'" style="width: 100%; height: 100%;">
                            </div>
                            <span class="info-name">{{ userInfo.userName }}</span>
                            <span class="info-num">账号ID：{{ userInfo.userId || '' }}<i
                                    class="ri-file-copy-line"></i></span>
                            <div class="message-btn">
                                <i class="ri-notification-2-line"></i>
                                <span>消息</span>
                            </div>
                        </div>
                        <div class="model-block">
                            <div class="model-block-item buyer" @click="goToUserCenter('buyer')">
                                <span class="item-text">买家中心</span>
                            </div>
                            <div class="model-block-item seller" @click="goToUserCenter('seller')">
                                <span class="item-text">卖家中心</span>
                            </div>
                        </div>
                        <div class="menu-block">
                            <div class="menu-block-item" v-for="item in menuList" :key="item.name"
                                @click="handleMenuClick(item)">
                                <i :class="`ri-${item.icon}-fill`"></i>
                                <span class="menu-name">{{ item.name }}</span>
                            </div>
                        </div>
                        <div class="box-footer">
                            <el-button type="text" class="footer-btn" @click="handleClick">账号设置</el-button>
                            <span class="split-line"></span>
                            <el-button type="text" class="footer-btn" @click="logout">退出登录</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getClassifyList } from '@/api/model'
import { getSceneClassifyList } from '@/api/scene'
import { getProductClassifyList } from '@/api/productClassify'
import { getMoreList } from '@/api/more'

export default {
    name: 'HeaderComponent',
    data() {
        return {
            searchText: '',
            menuList: [
                {
                    name: '点云管理',
                    icon: 'image',
                    path: '/user-center/seller/scenes'
                },
                {
                    name: '模型管理',
                    icon: 'instance',
                    path: '/user-center/seller/models'
                },
                {
                    name: '作品管理',
                    icon: 'image',
                    path: '/user-center/seller/products'
                },
                {
                    name: '我的收藏',
                    icon: 'book-marked',
                    path: '/user-center/buyer/favorites'
                },
                {
                    name: '我的订单',
                    icon: 'shopping-bag-4',
                    path: '/user-center/buyer/orders'
                },
                {
                    name: '我的足迹',
                    icon: 'footprint',
                    path: '/user-center/buyer/footprints'
                },
                {
                    name: '我的主页',
                    icon: 'account-pin-circle',
                    path: '/user-center/buyer'
                }
            ],
            modelList: [
                // {
                //     name: '免费3D模型',
                //     icon: 'icon-mianfei',
                //     value: 'free'
                // },
                // {
                //     name: '3ds Max模型',
                //     icon: 'icon-a-3dsmax',
                //     value: '3ds Max(.max)'
                // },
                // {
                //     name: 'Maya模型',
                //     icon: 'icon-maya',
                //     value: 'Maya(.ma/.mb)'
                // },
                // {
                //     name: 'Cinema 4D模型',
                //     icon: 'icon-c4d',
                //     value: 'Cinema 4D(.c4d)'
                // },
                // {
                //     name: 'Obj模型',
                //     icon: 'icon-obj',
                //     value: 'OBJ(.obj/.mtl)'
                // },
                // {
                //     name: 'FBX模型',
                //     icon: 'icon-fbx',
                //     value: 'FBX(.fbx)'
                // },
                // {
                //     name: 'Unity',
                //     icon: 'icon-unity',
                //     value: 'Unity'
                // },
                // {
                //     name: 'Unreal Engine',
                //     icon: 'icon-a-UnrealEngine',
                //     value: 'Unreal Engine'
                // }
                {
                    name: '免费3D模型',
                    icon: 'icon-mianfei',
                    value: 'free'
                },
                {
                    name: '3ds Max模型',
                    icon: 'icon-a-3dsmax',
                    value: '3ds Max(.max)'
                },
                {
                    name: 'Obj模型',
                    icon: 'icon-obj',
                    value: 'OBJ(.obj/.mtl)'
                },
                {
                    name: 'Maya模型',
                    icon: 'icon-maya',
                    value: 'Maya(.ma/.mb)'
                },
                {
                    name: 'Blender模型',
                    icon: 'icon-c4d',
                    value: 'Blender(.blend)'
                },
                {
                    name: 'STL模型',
                    icon: 'icon-fbx',
                    value: 'STL(.stl)'
                },
                {
                    name: 'Sketchup模型',
                    icon: 'icon-unity',
                    value: 'Sketchup(.skp)'
                },
                {
                    name: 'STEP模型',
                    icon: 'icon-a-UnrealEngine',
                    value: 'STEP(.stp)'
                },
                {
                    name: '犀牛Rhino模型',
                    cssIcon: 'format-rhino',
                    label: 'Rh',
                    value: 'Rhinoceros 3D(.3dm)'
                },
                {
                    name: '电商GLTF/GLB模型',
                    cssIcon: 'format-gltf',
                    label: 'GT',
                    value: 'glTF(.gltf/.glb)'
                },
                {
                    name: 'BIM模型',
                    cssIcon: 'format-bim',
                    label: 'BM',
                    value: 'Revit(.RVT/.RFA)'
                },
                {
                    name: 'VTK医学模型',
                    cssIcon: 'format-vtk',
                    label: 'VK',
                    value: 'VTK(.vtk)'
                }
            ],
            rbgList: [],
            sceneList: [
                {
                    name: '免费3D点云',
                    icon: 'icon-mianfei',
                    value: 'free'
                },
                {
                    name: 'LAS Cloud',
                    cssIcon: 'format-las',
                    label: 'LAS',
                    value: 'LAS Cloud(.las)'
                },
                {
                    name: 'PCD Cloud',
                    cssIcon: 'format-pcd',
                    label: 'PCD',
                    value: 'Point Cloud Library Cloud(.pcd)'
                },
                {
                    name: 'ASCII Cloud',
                    cssIcon: 'format-ascii',
                    label: 'ASC',
                    value: 'ASCII Cloud(.txt/.asc/.neu/.xyz/.pts/.csv)'
                },
                {
                    name: 'E57 Cloud',
                    cssIcon: 'format-e57',
                    label: 'E57',
                    value: 'E57 Cloud(.e57)'
                },
                {
                    name: 'PTX Cloud',
                    cssIcon: 'format-ptx',
                    label: 'PTX',
                    value: 'PTX Cloud(.ptx)'
                },
                {
                    name: 'PLY Cloud',
                    cssIcon: 'format-ply',
                    label: 'PLY',
                    value: 'PLY Cloud(.ply)'
                },
                {
                    name: 'CloudCompare Entities Cloud',
                    cssIcon: 'format-bin',
                    label: 'BIN',
                    value: 'CloudCompare Entities(.bin)'
                },
                {
                    name: 'RCP Cloud',
                    cssIcon: 'format-rcp',
                    label: 'RCP',
                    value: 'RCP Cloud(.rcp/.rcs)'
                }
            ],
            sceneRbgList: [],
            workClassifyList: [
                { classifyId: null, classifyName: '三维软件/点云/视觉图像等软件', icon: 'icon-c4d', childrenList: [] },
                { classifyId: null, classifyName: '点云数据处理/PCL/CloudCompare处理', cssIcon: 'format-pcl', label: 'PCL', childrenList: [] },
                { classifyId: null, classifyName: '点云数据/空间场景扫描点云', cssIcon: 'format-scan', label: 'SC', childrenList: [] },
                { classifyId: null, classifyName: '三维模型/定制模型/点云逆向建模', icon: 'icon-a-3dsmax', childrenList: [] },
                { classifyId: null, classifyName: '3D打印/作品展示', icon: 'icon-yulan', childrenList: [] },
                { classifyId: null, classifyName: '三维硬件/硬件产品', icon: 'icon-unity', childrenList: [] },
                { classifyId: null, classifyName: '其他', icon: 'icon-a-UnrealEngine', childrenList: [] }
            ],
            workHoveredClassify: null,
            defaultWorkClassify: null,
            industrySolutionList: [
                { id: 1, name: '建筑BIM', icon: 'ri-building-2-line', desc: '建筑信息模型定制', color: '#409EFF' },
                { id: 2, name: '工业制造', icon: 'ri-settings-3-line', desc: '工业产品3D定制', color: '#67c23a' },
                { id: 3, name: '医疗影像', icon: 'ri-heart-pulse-line', desc: '医学3D重建定制', color: '#f56c6c' },
                { id: 4, name: '文物保护', icon: 'ri-ancient-gate-line', desc: '文物数字化定制', color: '#e6a23c' },
                { id: 5, name: '地质测绘', icon: 'ri-map-2-line', desc: '测绘点云定制', color: '#9b59b6' },
                { id: 6, name: '数字孪生', icon: 'ri-cloud-line', desc: '数字孪生场景定制', color: '#1abc9c' },
                { id: 7, name: '影视动画', icon: 'ri-film-line', desc: '影视3D资产定制', color: '#e74c3c' },
                { id: 8, name: '逆向工程', icon: 'ri-scan-line', desc: '三维逆向定制', color: '#3498db' }
            ],
            moreMenuList: []
        }
    },
    computed: {
        userInfo() {
            return this.$store.state.user.userInfo
        },
        currentPath() {
            return this.$store.state.route.currentRoute.path
        },
        // 监听 store 中的搜索关键词
        storeKeyword() {
            return this.$store.state.search.keyword
        }
    },
    watch: {
        // 当 store 中的关键词变化时，同步到本地搜索框
        storeKeyword(newVal) {
            this.searchText = newVal
        }
    },
    methods: {
        goHome() {
            this.$store.dispatch('search/clearKeyword')
            window.location.href = '/';
        },
        handleNavClick(item) {
            if (item.path) {
                if (item.type === 'link') {
                    this.$store.dispatch('search/clearKeyword')
                    window.open(item.path, '_blank')
                } else if (item.type === 'page') {
                    this.$store.dispatch('search/clearKeyword')
                    this.$router.push(item.path).catch(() => { })
                }
            } else {
                this.$message.warning('敬请期待')
            }
        },
        handleSearch() {
            const keyword = this.searchText.trim()
            if (!keyword) {
                this.$message.warning('请输入搜索关键词')
                return
            }
            // 同步关键词到 store
            this.$store.dispatch('search/setKeyword', keyword)
            this.$router.push({
                path: '/product',
                query: { keyword }
            }).catch(() => { })
        },
        handleMenuClick(item) {
            if (item.path) {
                this.$router.push(item.path).catch(() => { })
            }
        },
        handleClick() {
            this.$router.push('/user-center/buyer/settings').catch(() => { })
        },
        nav_to(path) {
            this.$store.dispatch('search/clearKeyword')
            this.$router.push(path).catch(() => { })
        },
        nav_to_work() {
            this.$store.dispatch('search/clearKeyword')
            this.$router.push({ path: '/product', query: {} }).catch(() => { })
        },
        handleModelTypeClick(item) {
            this.$store.dispatch('search/clearKeyword')
            this.$router.push({
                path: '/model',
                query: { type: item.value }
            }).catch(() => { })
        },
        handleModelClassifyClick(item) {
            this.$store.dispatch('search/clearKeyword')
            this.$router.push({
                path: '/model',
                query: { classifyId: item.classifyId }
            }).catch(() => { })
        },
        handleSceneTypeClick(item) {
            this.$store.dispatch('search/clearKeyword')
            this.$router.push({
                path: '/scene',
                query: { type: item.value }
            }).catch(() => { })
        },
        handleSceneClassifyClick(item) {
            this.$store.dispatch('search/clearKeyword')
            this.$router.push({
                path: '/scene',
                query: { classifyId: item.classifyId }
            }).catch(() => { })
        },
        handleWorkClassifyHover(item) {
            this.workHoveredClassify = item
        },
        handleWorkClassifyClick(item) {
            this.$store.dispatch('search/clearKeyword')
            this.$router.push({
                path: '/product',
                query: { bigClassifyId: item.classifyId }
            }).catch(() => { })
        },
        handleWorkChildClassifyClick(child, parent) {
            this.$store.dispatch('search/clearKeyword')
            this.$router.push({
                path: '/product',
                query: { bigClassifyId: parent.classifyId, smallClassifyId: child.classifyId }
            }).catch(() => { })
        },
        handleIndustrySolutionClick(item) {
            this.$store.dispatch('search/clearKeyword')
            this.$router.push({
                path: '/product',
                query: { industryId: item.id }
            }).catch(() => { })
        },
        async getClassifyList() {
            try {
                // 获取模型分类
                const modelRes = await getClassifyList()
                if (modelRes.code === 200 && modelRes.data) {
                    this.rbgList = modelRes.data.map(item => ({
                        name: item.classifyName,
                        classifyId: item.classifyId
                    }))
                }

                // 获取点云分类
                const sceneRes = await getSceneClassifyList()
                if (sceneRes.code === 200 && sceneRes.data) {
                    this.sceneRbgList = sceneRes.data.map(item => ({
                        name: item.classifyName,
                        classifyId: item.classifyId
                    }))
                }

                // 获取作品分类
                const workRes = await getProductClassifyList()
                if (workRes.code === 200 && workRes.data) {
                    workRes.data.forEach(apiItem => {
                        const staticItem = this.workClassifyList.find(s => s.classifyName === apiItem.classifyName)
                        if (staticItem) {
                            staticItem.classifyId = apiItem.classifyId
                            staticItem.childrenList = apiItem.childrenList || []
                        }
                    })
                    // 默认显示第一个大类的子分类
                    const firstWithChildren = this.workClassifyList.find(s => s.childrenList && s.childrenList.length > 0)
                    if (firstWithChildren) {
                        this.defaultWorkClassify = firstWithChildren
                    }
                }
            } catch (error) {
                console.error('获取分类列表失败:', error)
            }
        },
        async fetchMoreMenu() {
            try {
                const res = await getMoreList()
                if (res.code === 200 && res.data) {
                    this.moreMenuList = res.data
                        .filter(item => item.status === '1')
                        .map(item => {
                            const isLink = item.isOuter === '1'
                            return {
                                id: item.configId,
                                name: item.configName,
                                type: isLink ? 'link' : 'page',
                                path: isLink ? item.linkUrl : `/more/detail?configId=${item.configId}`
                            }
                        })
                }
            } catch (error) {
                console.error('获取更多菜单失败:', error)
            }
        },
        async logout() {
            await this.$store.dispatch('user/logout')
            this.$router.push('/login').catch(() => { })
        },
        goToUserCenter(role) {
            const path = role === 'buyer' ? '/user-center/buyer' : '/user-center/seller'
            this.$router.push(path).catch(() => { })
        }
    },
    mounted() {
        // 获取分类列表
        this.getClassifyList()
        this.fetchMoreMenu()
    }
}
</script>

<style scoped lang="scss">
.header-container {
    background-color: #2b70b5;
    height: 60px;
    display: flex;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 999;

    .header-content {
        width: 100%;
        height: 100%;
        max-width: 1800px;
        margin: 0 auto;
        padding: 0 32px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        @media (max-width: 1350px) {
            padding: 0 16px;
        }
    }
}

.left-section {
    display: flex;
    align-items: center;
    flex: 1;

    .logo {
        display: flex;
        align-items: center;
        margin-right: 40px;
        cursor: pointer;

        @media (max-width: 1350px) {
            margin-right: 20px;
        }

        .logo-img {
            width: 32px;
            height: 32px;
            margin-right: 8px;
        }

        .logo-text {
            color: #fff;
            font-size: 18px;
            font-weight: bold;
            white-space: nowrap;
        }
    }
}

.nav-menu {
    .nav-list {
        display: flex;
        align-items: center;
        list-style: none;
        margin: 0;
        padding: 0;

        .nav-item {
            position: relative;
            height: 60px;
            display: flex;
            align-items: center;
            cursor: pointer;
            transition: background-color 0.3s;

            .nav-link {
                height: 100%;
                padding: 0 20px;
                color: #fff;
                font-size: 16px;
                white-space: nowrap;
                display: flex;
                align-items: center;
                user-select: none;

                @media (max-width: 1350px) {
                    padding: 0 12px;
                }

                .arrow-icon {
                    font-size: 20px;
                    transition: transform 0.3s ease-in-out;
                }
            }

            &:hover {
                background-color: #1f5183;
            }

            &.active {
                background-color: transparent;
                font-weight: 400;
            }

            // 下拉菜单样式
            &.has-dropdown {
                &:hover {
                    .arrow-icon {
                        transform: rotate(180deg);
                    }

                    .dropdown-menu {
                        opacity: 1;
                        visibility: visible;
                    }
                }

                .dropdown-menu {
                    position: absolute;
                    top: 100%;
                    left: 0;
                    z-index: 12;
                    opacity: 0;
                    visibility: hidden;

                    &.all-models {
                        display: flex;
                        align-items: stretch;
                        justify-content: normal;
                        top: 58px;
                        width: auto;
                        overflow: visible;
                        height: auto;
                        min-height: 296px;
                        box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.2);
                        border-radius: 10px 10px 10px 10px;
                        box-sizing: border-box;

                        .model-box {
                            display: grid;
                            grid-template-columns: repeat(2, min-content);
                            gap: 4px;
                            place-content: flex-start normal;
                            align-items: stretch;
                            padding: 16px 8px;
                            box-sizing: border-box;
                            background-color: rgba(49, 49, 49, 0.9);

                            &-item {
                                height: 40px;
                                display: flex;
                                align-items: center;
                                justify-content: flex-start;
                                column-gap: 10px;
                                color: #cbcbcb;
                                padding: 0 10px;
                                border-radius: 4px;
                                white-space: nowrap;
                                user-select: none;

                                &:hover {
                                    background-color: rgba(255, 255, 255, 0.08);
                                }
                            }
                        }

                        .rbg-box {
                            flex: 1;
                            min-height: 146px;
                            width: auto;
                            max-width: 780px;
                            display: grid;
                            grid-template-columns: repeat(4, auto);
                            gap: 8px 18px;
                            place-content: flex-start normal;
                            align-items: stretch;
                            padding: 16px 24px;
                            box-sizing: border-box;
                            background-color: rgba(25, 25, 25, 0.9);

                            &-item {
                                width: auto;
                                height: 40px;
                                display: flex;
                                align-items: center;
                                justify-content: flex-start;
                                column-gap: 14px;
                                color: #cbcbcb;
                                user-select: none;
                                white-space: nowrap;
                            }
                        }

                        // 模型库样式（红色主题）
                        &.model-menu {
                            .model-box-item:hover {
                                background-color: rgba(255, 255, 255, 0.08);
                                color: #4a9eff;

                                .format-icon {
                                    background-color: #4a9eff;
                                    color: #000;
                                    border-color: #4a9eff;
                                }
                            }

                            .rbg-box-item:hover {
                                color: #4a9eff;
                            }
                        }

                        // 点云库样式（蓝色主题）
                        &.scene-menu {
                            .model-box-item:hover {
                                background-color: rgba(255, 255, 255, 0.08);
                                color: #fc4c4b;

                                .format-icon {
                                    background-color: #fc4c4b;
                                    color: #000;
                                }
                            }

                            .rbg-box-item:hover {
                                color: #fc4c4b;
                            }
                        }

                        // 作品库样式（绿色主题）
                        &.work-menu {
                            min-height: auto;

                            .model-box {
                                grid-template-columns: 1fr;
                                flex: none;
                            }

                            .model-box-item:hover {
                                background-color: rgba(255, 255, 255, 0.08);
                                color: #67c23a;

                                .format-icon {
                                    background-color: #67c23a;
                                    color: #000;
                                    border-color: #67c23a;
                                }
                            }

                            .rbg-box {
                                display: grid;
                                grid-template-columns: auto auto;
                                gap: 8px 12px;
                                width: auto;
                                min-width: 200px;
                                max-width: 500px;
                                padding: 16px 24px 16px 36px;

                                .rbg-box-item {
                                    width: auto;
                                    white-space: nowrap;
                                    height: 40px;
                                    display: flex;
                                    align-items: center;
                                    justify-content: flex-start;
                                    column-gap: 14px;
                                    color: #cbcbcb;
                                    user-select: none;
                                }
                            }

                            .rbg-box-item:hover {
                                color: #67c23a;
                            }
                        }

                        // 行业解决方案样式（绿色主题）
                        &.industry-menu {
                            min-height: auto;

                            .model-box-item:hover {
                                background-color: rgba(255, 255, 255, 0.08);
                                color: #67c23a;
                            }
                        }
                    }

                    // 更多菜单样式
                    &:not(.all-models) {
                        background-color: rgba(25, 25, 25, 0.95);
                        min-width: 180px;
                        padding: 8px 0;
                        box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.2);
                        border-radius: 4px;
                        transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;

                        &.more-menu {
                            display: grid;
                            grid-template-columns: 1fr 1fr;
                            width: 314px;
                            background-color: rgba(0, 0, 0, 0.8);
                            box-shadow: 0 4px 5px #151515;
                            border-radius: 0;
                            padding: 0;

                            .dropdown-item {
                                height: 40px;
                                padding: 0;
                                text-align: center;
                                line-height: 40px;
                                border-radius: 0;
                                border-left: 4px solid transparent;

                                &:hover {
                                    border-left: 4px solid #235b93;
                                    background-color: #191919;
                                }
                            }
                        }

                        .dropdown-item {
                            padding: 12px 16px;
                            color: #cbcbcb;
                            font-size: 14px;
                            cursor: pointer;
                            white-space: nowrap;
                            user-select: none;
                            border-radius: 4px;
                            transition: all 0.2s;
                        }
                    }

                }
            }
        }
    }

    // 3D点云库 格式文字图标
    .format-icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 14px;
        height: 14px;
        font-size: 6px;
        font-weight: bold;
        font-style: normal;
        color: #333;
        background-color: #fff;
        border-radius: 2px;
        flex-shrink: 0;
        letter-spacing: 0;
        line-height: 1;
        padding: 0;
        box-sizing: border-box;

        &.format-las {
            border-radius: 50%;
        }

        &.format-pcd {
            border-radius: 3px;
        }

        &.format-ascii {
            border-radius: 2px;
            transform: rotate(45deg);
            line-height: 0;

            // 文字反向旋转保持水平
            &::after {
                content: attr(data-label);
                transform: rotate(-45deg);
                font-size: 5px;
                font-weight: bold;
            }
        }

        &.format-e57 {
            clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
            border-radius: 0;
        }

        &.format-ptx {
            border-radius: 999px;
        }

        &.format-ply {
            clip-path: polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%);
            border-radius: 0;
        }

        &.format-bin {
            clip-path: polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%);
            border-radius: 0;
        }

        &.format-rcp {
            clip-path: polygon(50% 0%, 90% 20%, 100% 60%, 75% 100%, 25% 100%, 0% 60%, 10% 20%);
            border-radius: 0;
        }

        // 3D模型库文字图标
        &.format-rhino {
            clip-path: polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%);
            border-radius: 0;
        }

        &.format-gltf {
            clip-path: polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%);
            border-radius: 0;
        }

        &.format-bim {
            border-radius: 50% 50% 2px 2px;
        }

        &.format-vtk {
            width: 18px;
            height: 18px;
            clip-path: polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%);
            border-radius: 0;
            transform: rotate(45deg);

            // 文字反向旋转保持水平
            line-height: 0;
            font-size: 0;

            &::after {
                content: 'VK';
                transform: rotate(-45deg);
                font-size: 5px;
                font-weight: bold;
            }
        }

        // 3D定制作品库文字图标
        &.format-pcl {
            clip-path: polygon(50% 0%, 93% 25%, 93% 75%, 50% 100%, 7% 75%, 7% 25%);
            border-radius: 0;
        }

        &.format-scan {
            border-radius: 50%;
            background-color: #fff;
            border: 2px dashed #333;
            box-sizing: border-box;
        }
    }
}

.center-section {
    flex: 1;
    max-width: 500px;
    margin: 0 30px;
    display: flex;
    align-items: center;
    justify-content: center;

    @media (max-width: 1350px) {
        margin: 0 15px;
    }

    .search-box {
        .search-input {
            ::v-deep {
                .el-input__inner {
                    width: 240px;
                    height: 40px;
                    margin-bottom: 0;
                    padding: 0 15px;
                    border: none;
                    background-color: #235b93;
                    border-radius: 4px 0 0 4px;
                    box-sizing: border-box;
                    font-size: 14px;
                    line-height: 40px;
                    color: #fff;

                    &::placeholder {
                        color: #409EFF;
                    }
                }

                .el-input-group__append {
                    width: 50px;
                    min-width: 50px;
                    height: 40px;
                    border: none;
                    padding: 0;
                    background-color: #409EFF;
                    border-radius: 0 4px 4px 0;
                    font-size: 14px;
                    line-height: 40px;
                    text-align: center;
                    color: #ffebeb;
                    cursor: pointer;
                }
            }
        }
    }
}

.right-section {
    height: 100%;
    display: flex;
    align-items: center;
    white-space: nowrap;

    .auth-btn {
        color: #fff !important;
        font-size: 16px;
        padding: 0 10px;

        &:hover {
            color: #fff !important;
            opacity: 0.8;
        }
    }

    .avatar-box {
        height: 100%;
        position: relative;
        display: flex;
        align-items: center;
        cursor: pointer;

        .user-box {
            position: absolute;
            top: 100%;
            right: -12px;
            display: flex;
            flex-direction: column;
            flex-wrap: nowrap;
            place-content: normal normal;
            align-items: normal;
            padding: 0 20px;
            width: 390px;
            background: #353535;
            box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.5);
            border-radius: 0 0 10px 10px;
            box-sizing: border-box;
            opacity: 0;
            visibility: hidden;
            transition: all 0.1s;

            .info-block {
                padding-top: 20px;
                width: 100%;
                display: grid;
                grid-template-areas:
                    'avatar name message'
                    'avatar id message';
                grid-template-columns: 62px 1fr min-content;
                grid-template-rows: auto auto;
                align-items: center;
                justify-content: center;
                gap: 0 10px;

                .el-avatar {
                    grid-area: avatar;
                    border: 1px solid rgba(255, 255, 255, 0.8);
                }

                .info-name {
                    grid-area: name;
                    color: #FFF;
                    font-size: 20px;
                    width: 100%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .info-num {
                    grid-area: id;
                    color: rgba(255, 255, 255, 0.5);

                    i {
                        color: inherit;
                        margin-left: 5px;
                    }
                }

                .message-btn {
                    grid-area: message;
                    padding: 0 10px 0 9px;
                    height: 24px;
                    background: rgba(255, 255, 255, 0.1);
                    border-radius: 4px;
                    border: 1px solid rgba(255, 255, 255, 0.15);
                    color: #ffffff;
                    font-size: 12px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 0 5px;
                    margin-top: auto;
                    cursor: pointer;
                }
            }

            .model-block {
                margin: 26px 0 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                column-gap: 20px;

                &-item {
                    flex: 1;
                    height: 66px;
                    border-radius: 4px;

                    .item-text {
                        display: flex;
                        align-items: center;
                        justify-content: flex-start;
                        width: 100%;
                        height: 100%;
                        padding-left: 66px;
                        background-repeat: no-repeat;
                        background-size: 60px 66px;
                        box-sizing: border-box;
                        font-size: 16px;
                        color: rgba(255, 255, 255, 0.8);
                    }

                    &.buyer {
                        background: linear-gradient(270deg, #3c3c3c 0%, #714b33 100%);

                        .item-text {
                            background-image: url('@/assets/images/header-buyer.png');
                        }
                    }

                    &.seller {
                        background: linear-gradient(270deg, #434343 0%, #6f3d3d 100%);

                        .item-text {
                            background-image: url('@/assets/images/header-seller.png');
                        }
                    }
                }
            }

            .menu-block {
                display: grid;
                grid-template-columns: repeat(3, 1fr);
                padding-bottom: 20px;

                &-item {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    row-gap: 5px;
                    width: 100%;
                    height: 80px;
                    color: rgba(255, 255, 255, 0.8);

                    i {
                        font-size: 20px;
                        color: inherit;
                    }

                    &:hover {
                        background: #272727;
                        border-radius: 4px;
                        color: #ffffff;
                    }
                }
            }

            .box-footer {
                padding: 20px 0;
                border-top: 1px solid #2e2e2e;
                display: flex;
                align-items: center;
                justify-content: flex-end;

                .footer-btn {
                    padding: 0;
                    color: #ffffff;
                    opacity: 0.5;
                    font-size: 14px;

                    &:hover {
                        opacity: 1;
                    }
                }

                .split-line {
                    display: block;
                    margin: 4px 10px 0;
                    width: 1px;
                    height: 14px;
                    background: #2e2e2e;
                    line-height: 22px;
                }
            }
        }

        &:hover {
            .user-box {
                opacity: 1;
                visibility: visible;
            }
        }
    }
}
</style>
